var analyticsCookie = localStorage.getItem("analytics_cookies");
var googleTagManagerNoscript = document.querySelector("#google-tag-manager-noscript");

if (analyticsCookie == "false") {
    googleTagManagerNoscript.remove();
}
